module.exports = __webpack_public_path__ + "static/media/quarterlyvisitdue-icon.536a824e.svg";